import React from "react";

export default function DeliveryReturnPolicy() {
  return (
    <div className="max-w-7xl mx-auto p-6 text-gray-800 leading-relaxed">
      {/* Title */}
      <h3 className="text-2xl font-bold mb-2">Delivery and Return Policy</h3>

      {/* Section 1 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">Delivery Area</h3>
      <p className="mb-4 mt-6 text-black text-md">
        <strong>Guru Sports </strong> delivers to all locations within the
        geographical boundary of India. We do not deliver to International
        locations at this time but will soon be able to fulfill all such orders
        with advance payment options and respective Custom Duties and taxes of
        other countries.
      </p>

      {/* Section 2 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">Delivery Methods</h3>
      <p className="mb-4 mt-6 text-black text-md">
        <strong>GURU.com</strong> dispatches all parcels using best service
        provider in the field of courier to offer you fast and reliable
        delivery. You can track your delivery by logging to our courier
        partner’s website.
      </p>

      {/* Section 3 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">Charges</h3>
      <p className="mb-4 mt-6 text-black text-md">
        For deliveries within India, prepaid orders using any form of payment
        methods including PayU, Debit Cards and Credit Cards available on the
        GURU platform, will be delivered free of charge.
      </p>

      {/* Section 4 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">Cash On Delivery</h3>
      <p className="mb-4 mt-6 text-black text-md">
        Cash on delivery option is currently available in India. If the chosen
        mode of payment is cash on delivery, a variable convenience charge will
        apply, including Rs. 130 flat charges for such orders. You can view the
        delivery charges at the time of payment. These are over and above the
        selling price of the product. You can also view the delivery charges in
        the invoice or My Order section.
      </p>

      {/* Section 5 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">Delivery Times</h3>
      <p className="mb-4 mt-6 text-black text-md">
        The goods will be delivered within 3-5 working days from the date of
        dispatch for all deliveries within India. Estimated delivery times are
        available from the moment you place your order. Only in some rare cases
        when the products are out of stock the dispatch date is 15-20 days
        approx. Once your parcel has been dispatched by our Logistics team, an
        email will be sent to you.
      </p>

      {/* Section 6 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">Delivery Problems</h3>
      <p className="mb-4 mt-6 text-black text-md">
        Despite our best efforts and those of our courier partner, certain
        issues can arise before your parcel is delivered. In order to guarantee
        you seamless service quality, <strong>GURU.com</strong> promises to do
        its best to find the causes and resolve the problem in a timely manner.
      </p>

      {/* Section 7 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">Track Order Online</h3>
      <p className="mb-4 mt-6 text-black text-md">
        Once your parcel has been dispatched, an email containing your parcel
        information is sent to you. You can then follow your parcel’s progress
        on our courier partner website by going to the My Account → My Orders
        section. If you are unable to view any information regarding your
        parcel, we recommend that you contact us so we can follow up on your
        order at <strong>coordinator@GURU.com</strong> or call/WhatsApp at{" "}
        <strong>+91-9803061407</strong>.
      </p>

      {/* Section 8 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">
        What if I am not available at the time of delivery?
      </h3>
      <p className="mb-4 mt-6 text-black text-md">
        Should you not be present when our courier attempts to deliver your
        parcel, a message/call will be left for your information. If your
        neighbour/help/driver/family member has accepted it on your behalf, the
        delivery will be considered ‘Delivered’. However, a second attempt will
        automatically be made after 48 hours if no one was present at the given
        address. After the second attempt, our courier will hold on to your
        parcel for 2 days awaiting further instructions before returning it.
        Once the parcel has been sent back to us, you must wait until it arrives
        in our warehouse. We will re-dispatch it as per your instructions. You
        will have to bear re-delivery charges which may vary.
      </p>

      {/* Section 9 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">Damaged Parcel</h3>
      <p className="mb-4 mt-6 text-black text-md">
        Please make a video while opening the parcel. No complaints will be
        entertained regarding damage and missing product without Parcel Opening
        Video.
      </p>
      <p className="mb-4 mt-6 text-black text-md">
        If you notice your parcel is damaged upon delivery, you should refuse to
        accept it. All parcels are guaranteed to be in perfect condition when
        they are dispatched from our warehouse, complete with security tape that
        should be visible and intact. Send us an email at{" "}
        <strong>coordinator@GURU.com</strong> stating that you have refused to
        accept the damaged parcel within 24 hours. We will arrange pickup of the
        parcel. If pickup is not available in your area, you may send it back
        through any convenient mode (customer bears the charges). It should
        reach us within 7 days. We will resend the same article without charges,
        or issue a credit note if out of stock. No complaints will be
        entertained after wear and tear, and no refunds will be given in such
        cases.
      </p>

      {/* Section 10 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">
        What to do if a damaged parcel has been delivered?
      </h3>
      <p className="mb-4 mt-6 text-black text-md">
        Please make a video while opening the parcel. No complaints will be
        entertained regarding damage and missing product without Parcel Opening
        Video.
      </p>
      <p className="mb-4 mt-6 text-black text-md">
        If your parcel was left with someone else on your behalf and it is
        damaged, the parcel is considered ‘Accepted’. If on opening your parcel
        you notice that items are damaged or missing, please inform us within 24
        hours by sending an email at <strong>coordinator@GURU.com</strong>.
      </p>

      {/* Section 11 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">
        I have only received part of my order.
      </h3>
      <p className="mb-4 mt-6 text-black text-md">
        Please make a video while opening the parcel. No complaints will be
        entertained regarding damage and missing product without Parcel Opening
        Video.
      </p>
      <p className="mb-4 mt-6 text-black text-md">
        Please be aware that your order may be dispatched in separate parcels on
        different dates. If you have only received part of your order, check the
        delivery tracking page in the My Account → My Orders section. If
        shipment is ongoing, the missing items will be delivered shortly. If the
        shipment dates have lapsed and you have not received your entire order,
        please contact customer care at <strong>coordinator@GURU.com</strong>.
      </p>

      {/* Section 12 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">
        What to do if I want to return and refund?
      </h3>
      <p className="mb-4 mt-6 text-black text-md">
        For return and exchange requests, please refer to our FAQ –
        Cancellation, Returns & Exchange section, where all details regarding
        our return and exchange policies are provided.
      </p>

      {/* Section 13 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">Still Need help?</h3>
      <p className="mb-4 mt-6 text-black text-md">
        Contact us at Call: <strong>+91-9803061407</strong> or Email:{" "}
        <strong>coordinator@GURU.com</strong>
        for questions related to refunds and returns.
      </p>
    </div>
  );
}
